import { useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../../styles/test-system.css';

/* The section the rail calls "Certificates", named once, here: the rail item, the
   dashboard's section title and this header all say the same word. */
export const SECTION_NAME = 'Certificates';

/* The candidate-facing pages of the section. Kept in one place so every page in
   the set carries the same set of links in the same order. Each label is the
   title of the page it opens — "My certificates" rather than a second, smaller
   "Certificates" under the section's own name. */
const LINKS = [
    { to: '/tests', label: 'Test catalog' },
    { to: '/tests/enrolments', label: 'My enrolments' },
    { to: '/tests/entries', label: 'Entries' },
    { to: '/tests/certificates', label: 'My certificates' },
    { to: '/tests/application', label: 'Application' },
];

/**
 * The section header: the section's name and its pages as a row of tabs on one
 * rule, at the top of every page in the set.
 */
const TestNav = () => {
    const { pathname } = useLocation();
    const strip = useRef(null);
    const current = useRef(null);

    /* On a phone the tabs scroll sideways, and the page that is open is brought to
       the middle of the strip rather than left off its edge. Only the strip moves:
       the page itself is never scrolled from here. */
    useEffect(() => {
        const nav = strip.current;
        const tab = current.current;
        if (!nav || !tab || nav.scrollWidth <= nav.clientWidth) return;
        nav.scrollLeft = tab.offsetLeft - (nav.clientWidth - tab.offsetWidth) / 2;
    }, [pathname]);

    return (
        <div className="ts-section">
            <span className="ts-section-name" id="ts-section-name">{SECTION_NAME}</span>
            <nav className="ts-nav" ref={strip} aria-labelledby="ts-section-name" data-testid="test-nav">
                {LINKS.map(({ to, label }) => {
                    const active = pathname === to;

                    return (
                        <Link
                            key={to}
                            to={to}
                            ref={active ? current : undefined}
                            className={`ts-nav-link${active ? ' ts-nav-link--active' : ''}`}
                            aria-current={active ? 'page' : undefined}
                        >
                            {label}
                        </Link>
                    );
                })}
            </nav>
        </div>
    );
};

export default TestNav;
